import { CSSObject } from '@chakra-ui/react';

export const GroupText: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'bold',
  fontFamily: 'accent',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
};
export const TextBetCount: CSSObject = {
  fontSize: 'xs',
  fontFamily: 'body',
  fontWeight: 'bold',
  pl: '0.5',
  color: 'beta.300',
  pos: 'relative',
  bottom: '2px',
};
export const GroupChevron: CSSObject = {
  bgGradient: 'linear(to-b, beta.300, beta.400)',
  borderRadius: 'md',
  boxShadow:
    '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset',
  color: 'blackAlpha.800',
  fontFamily: 'accent',
  fontSize: 'sm',
  fontWeight: 'normal',
  textTransform: 'capitalize',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.5)',
  boxSize: '6',
  minW: 'unset',
  border: 'none',
  transition: 'none',
  _hover: {
    bgGradient: 'linear(to-b, beta.500, beta.500)',
    bg: 'beta.500',
    boxShadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 2px rgba(0, 0, 0, 0.2) inset',
    border: '1px solid',
    borderColor: 'rgba(255, 255, 255, 0.65)',
  },
  '&&&': {
    '& > span, & > svg': { zIndex: 9, transition: 'none' },
  },
  ':active, &[data-active="true"]': {
    bg: 'blackAlpha.700',
    boxShadow:
      '0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.08)',
    color: 'beta.300',
    textShadow: 'none',
  },
};
export const FlexGroupWrapper: CSSObject = {
  mb: '1.5',
};
export const GroupIcon: CSSObject = {
  color: 'white',
};
